import { Chip, Tooltip } from "@mui/material"
import GameToolTip from "../components/Tooltips/GameToolTip"
import MatchToolTip from "../components/Tooltips/MatchToolTip"
import { RankColors, RankText, TeamsList, TeamLogos} from "./Globals"
import { Match, Game, Rank, Position, Placing, Diff, PlayerOwnership, PlacingWithCaptainVice, DiffWithCaptainsVice, Dismissal, Player } from "../types/types"
import { GridColDef, GridRenderCellParams} from "@mui/x-data-grid"
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CaptainCard from "../components/Cards/CaptainCard"
import { ConstructionOutlined } from "@mui/icons-material"
import _ from 'underscore';
import { TABLETOOLTIPS } from "./ToolTips"

export function RenderPriceCell(price:number, price_change:number, ) {
    return (<div style={{width: "100%", justifyContent: "flex-start", display: "flex"}}>
            <span>
                {price?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})}
            </span>
            &nbsp;
            <span style={{color: price_change > -1 ? 'green' : 'red'}}> 
                ({price_change > -1 ? '+' : ''}{price_change?.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0})})
            </span>
    </div>)
}

export function RenderTeamCellName(name) {
    let colors:string[] = ['',''];
    if (name in TeamsList) {
        colors =TeamsList[name];
    }
     
    let logo = TeamLogos[name];
    return (<div style={{
        display: "flex", 
        width: '100%', 
        height: '38px', 
        alignItems: 'center', 
        background: `linear-gradient(120deg, ${colors[0]} 0%, ${colors[0]} 50%, ${colors[1]} 50%)`, 
        color: "white"
    }}>
    <img style={{height: "1.5rem", width: "2rem"}} src={logo} alt="Team logo"/>
    <p>{name}</p>
    </div>)
}


export function RenderTeamCell(name:string, logo:string, colors:string[]) {
    return (<div style={{display: "flex", width: '100%', height: '38px', alignItems: 'center', background: `linear-gradient(120deg, ${colors[0]} 0%, ${colors[0]} 50%, ${colors[1]} 50%)`, color: "white"}}>
    <img style={{height: "1.5rem", width: "2rem"}} src={logo} alt="Team logo"/>
    <p>{name}</p>
</div>)
}

export function RenderTeamCellToolTip(name:string, logo:string, colors:string[], match:Match) {
    if (!colors) {
        colors = ['',''];
    }
    return (<Tooltip arrow title={<MatchToolTip match={match}/>}>
        {RenderTeamCell(name,logo,colors)}
    </Tooltip>)
}

export function RenderVSTeamCell(team1:string, team2:string) {
    return <div>
        <div style={{display: "flex", width: "100%", height:38, alignItems: "center"}}>
            <img src={{team1}}></img>
            <img src={{team2}}></img>
        </div>
    </div>
}

export function RenderTeamCellToolTipGame(name:string, logo:string, colors:string[], game:Game) {
    return (<Tooltip arrow title={<GameToolTip game={game}/>}>
        {RenderTeamCell(name,logo,colors)}
    </Tooltip>)
}

export function RenderRankCell(ranks: Rank[]) {
    return (<div style={{display: "flex", columnGap: "0.75rem", overflowY: "hidden", overflowX:"scroll"}}>
        {ranks.map(function(rank) {
            return (<div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                
                <Chip onDelete={e => console.log("")} label={`${rank.position.name}:`} style={{backgroundColor: RankColors[rank.rank]}} deleteIcon={<span style={{lineHeight: "1"}}>{RankText[rank.rank]}</span>}/>
            </div>
            )
        })}
        
    </div>

    )
}

export function RenderPositionCell(positions: Position[]) {
    return <div style={{display: "flex", columnGap: "0.75rem", overflowY: "hidden", overflowX:"scroll" }}>
        {positions.map(function(position) {
            return (<a href={`/position/${position.name}`}>
            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <Chip 
                    onDelete={e => console.log("")} 
                    label={`${position.name}`} 
                    deleteIcon={<span style={{lineHeight: "1"}}></span>}
                    />
                </div>
            </a>) 
        })}
    </div>
}

export const PlayerGamesColumns:GridColDef[] = [
    { field: 'season', headerName: 'Season', renderCell: (params) => {
        console.log("Season Params: ", params,TABLETOOLTIPS[params.field], TABLETOOLTIPS);
        return (<Tooltip title={TABLETOOLTIPS[params.field]}>
            <span>{params.value}</span>
        </Tooltip>)
    } },
    { field: 'round', headerName: 'Rd' , type: "number", width: 50 },
    
    { field: 'opposition', headerName: 'Opponent', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCellToolTip(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors,params.row.game))
    },
    { field: 'price', headerName: 'Price' , type: "number", width: 180, 
        renderCell: (params: GridRenderCellParams<Date>) => (RenderPriceCell(params.row.price, params.row.price_change)
        
    ), 
        sortComparator: (v1, v2) => { return 1}
    },
    { field: 'playerRole', headerName: 'Role' , width: 150 },
    { field: 'points', headerName: 'Points' , type: "number" },
    { field: 'runs', headerName: 'Runs' , type: "number" },
    { field: 'fours', headerName: 'Fours' , type: "number" },
    { field: 'wickets', headerName: 'Wickets' , type: "number" },
    { field: 'maiden_overs', headerName: 'Maiden Overs' , type: "number" },
    { field: 'dotballs', headerName: 'Dot Balls' , type: "number" },
    { field: 'catches', headerName: 'Catches' , type: "number" },
    { field: 'stumpings', headerName: 'Stumpings' , type: "number" },
    { field: 'scbe', headerName: 'BE' },
    // { field: "posrdrank", headerName: "Pos RD Rnk"},
    // { field: "postotalrank", headerName: "Pos Total Rnk"},
    // { field: 'nextroundpoints', headerName: "Next Round Predicted Points", type: 'number', width: 180},
    // { field: 'nextroundprice', headerName: 'Predicted Price' , type: "number", width: 180, 
    //     renderCell: (params: GridRenderCellParams<Date>) => (RenderPriceCell(params.row.nextroundprice, params.row.predictedPriceChange)), 
    //     sortComparator: (v1, v2) => { return 1}
    // },
    { field: 'navigatebutton', headerName: '' ,renderCell: (params: GridRenderCellParams<Date>) => (
        <KeyboardArrowRightIcon />)
    },
];

export function PopulateMatchRows(matches:Match[],aboutTeam:string) {
    let newRows = [];

    matches.map(function(match) {
        let opposition = '';
        let oppositionscore = '';
        let aboutTeamScore = '';

        match.teams.map(function(team) {
            if (team.name !== aboutTeam) {
                opposition = team.name;
            }
        });
        if (match.hometeam) {
            if (match.hometeam.name === opposition) {
                oppositionscore = `${match.homescore}`;
                aboutTeamScore = `${match.awayscore}`;

            } else {
                oppositionscore = `${match.awayscore}`;
                aboutTeamScore = `${match.homescore}`;
            }
        }
        let oppositioncolors:string[] = TeamsList[opposition];

        newRows.push({
            id: `${match.id}`,
            matchid: `${match.id}`,
            opposition: opposition,
            oppositionscore: oppositionscore,
            round: match.round,
            date: match.date,
            location: match.location,
            oppositionlogo: TeamLogos[opposition],
            oppositioncolors: oppositioncolors,
            aboutteamscore: aboutTeamScore,
            match: match,
        });
    });
    return newRows;

}

export const MatchTableColumns:GridColDef[] = [
    { field: 'round', headerName: 'Round'},
    { field: 'date', headerName: 'Date'},
    { field: 'opposition', headerName: 'Opponent', width: 180,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCellToolTip(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors,params.row.match))
    },
    { field: 'oppositionscore', headerName: 'Opposition Score', width: 140},
    { field: 'aboutteamscore', headerName: 'Team Score', width: 140},
]

export const PlacingTableColumns:GridColDef[] = [
    { field: "name", headerName: "Team Name", flex: 1},
    { field: "ranking", headerName: "Ranking", flex: 1},
    { field: "round_ranking", headerName: "Round Ranking", flex: 1},
]

export function RenderHomePlacingTableColumns(placings:Placing[]) {
    let rows = [];
    placings.map(function(placing){
        rows.push({
            id: placing.team.name,
            teamid: placing.team.id,
            name: placing.team.name,
            ranking: placing.position,
            round_ranking: placing.round_position,
        });
    });
    return rows;  
}

export const TopNPlacingsTableColumns:GridColDef[] = [
    { field: 'teamname', headerName: 'Name',flex:1 },
    { field: 'thisround_position', headerName: 'This Round Ranking',flex:1 },
    { field: 'lastround_position', headerName: 'Last Round Ranking',flex:1 },
    { field: 'diff', headerName: 'Change',flex:1,
        renderCell: (params: GridRenderCellParams<Date>) => {
            let increase = params.row.diff > 0;
            return <div style={{color: increase ? 'green' : 'red',display: "flex", alignItems: 'center'}}>
                {params.row.diff} 
                {increase ? <TrendingUpIcon style={{color: "green",marginLeft: "0.25rem"}} /> : <TrendingDownIcon style={{color: "red",marginLeft: "0.25rem"}} />}
            </div>
        }
    },
    { field: 'captains', headerName: 'Captain/Vice',flex:1,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderCaptainViceCell(params.row.captain,params.row.vice))
    },
]; 
export function RenderTopNPlacingTableColumns(diffs: DiffWithCaptainsVice[]) {
    let rows = [];
    
    if (diffs) {
        diffs.map(function(diff) {
            rows.push({
                id: diff.team.name,
                teamid: diff.team.id,
                thisround_position: diff.thisround,
                lastround_position: diff.lastround,
                diff: diff.diff,
                teamname: diff.team.name,
                captain: diff.captain,
                vice: diff.vice,
            })
        });
    }
    return rows;
}

export const PlayerOwnershipTableColumns:GridColDef[] = [
    
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'played', headerName: 'Played', width: 100 },
    { field: 'opposition', headerName: 'Opponent', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCellToolTip(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors,params.row.game))
    },
    { field: 'price', headerName: 'Price' , type: "number", width: 180, 
        renderCell: (params: GridRenderCellParams<Date>) => (RenderPriceCell(params.row.price, params.row.price_change)
        
    ), 
    sortComparator: (v1, v2) => { return 1}
    },
    { field: 'points', headerName: 'Points' , type: "number" },
    { field: 'scbe', headerName: 'BE' , type: "number" },
    { field: 'positions', headerName: 'Position' , width: 200,
        renderCell: (params: GridRenderCellParams<Date>) => RenderPositionCell(params.row.positions)
    },
    // { field: "posrdrank", headerName: "Pos RD Rnk"},
    // { field: "postotalrank", headerName: "Pos Total Rnk"},
];

export function BuildPlayerOwnershipTable(playerOwnerships:PlayerOwnership) {
    const playedItems = {
        'true': "Started",
        'false': 'Bench',
        'emerg': "Emergency",
        'capt': "Captain",
        'vice': "Vice",
    }
    let rows = [];
    if (playerOwnerships && playerOwnerships.players) {
        
        playerOwnerships.players.map(function(player) {
            
            let thegame = player.player.stats[0]?.lastgame;
            let theplayer = player.player;
            
            if (thegame && theplayer) {
                let oppositionname = thegame.opposition?.name ? thegame?.opposition?.name : '';
                let oppositioncolors:string[] = TeamsList[oppositionname];
                let predictedPriceChange:number = thegame.nextRoundPredictedPrice - thegame.price;

                rows.push({
                    id: theplayer.id,
                    name: `${theplayer.firstname} ${theplayer.lastname}`,
                    played: playedItems[player.played],
                    opposition: oppositionname,
                    oppositionlogo: TeamLogos[oppositionname],
                    oppositioncolors: oppositioncolors,
                    price: thegame.price.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}),
                    price_change: thegame.price_change,
                    positions: thegame.positions,
                    game: thegame,
                    points: thegame.points,
                    scbe: thegame.scbe
                });
            }
        }); 
    }
    return rows;
}

function RenderRankingCell(current,change, isIncrease) {
    
    return <div style={{display: "flex", alignItems: "center"}}>
        {current}
        <div style={{display: "flex", alignItems: "center",fontSize: "1rem", color: isIncrease ? "green" : "red"}}>
            {isIncrease ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            {change}
        </div>
    </div>
}

function RenderCaptainViceCell(captain,vice) {
    return <div style={{display: "flex", columnGap: "1rem", alignItems: "center"}}>
        <CaptainCard player={captain.player} played="capt" compact={true}/>
        <CaptainCard player={vice.player} played="vice" compact={true}/>
    </div>
}


export const PlacingsWithCaptainsCols:GridColDef[] = [
    { field: 'teamname', headerName: 'Name', width: 200 },
    { field: 'position', headerName: 'Rank' , width: 200,
        renderCell: (params: GridRenderCellParams<Date>) => RenderRankingCell(params.row.position, params.row.position_change,params.row.position_change > 0)
    },
    { field: 'round_position', headerName: 'Round Rank' , width: 200,
        renderCell: (params: GridRenderCellParams<Date>) => RenderRankingCell(params.row.round_position, params.row.round_position_change,params.row.round_position_change > 0)
    },
    { field: 'price', headerName: 'Price' , width: 250,
        renderCell: (params: GridRenderCellParams<Date>) => RenderRankingCell(params.row.price.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}), params.row.price_change.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}),params.row.price_change > 0)
    },
    { field: 'captain', headerName: 'Captain/Vice' , width: 250,
        renderCell: (params: GridRenderCellParams<Date>) => RenderCaptainViceCell(params.row.captain,params.row.vice)
    },
]

export const LocationPerformanceTable:GridColDef[] = [
    { field: 'name', headerName: 'Location', width: 200 },
    { field: 'games', headerName: 'Games Played', width: 200 },
    { field: 'wickets', headerName: 'Average Wickets', width: 200 },
    { field: 'runs', headerName: 'Average Runs', width: 200 },
    { field: 'points', headerName: 'Average Points', width: 200 },
]

export const TeamPerformanceTable:GridColDef[] = [
    { field: 'name', headerName: 'Opposition', width: 200,
        renderCell: (params: GridRenderCellParams<Date>) => RenderTeamCellName(params.row.name)
    },
    { field: 'games', headerName: 'Games Played', width: 200 },
    { field: 'wickets', headerName: 'Average Wickets', width: 200 },
    { field: 'runs', headerName: 'Average Runs', width: 200 },
    { field: 'points', headerName: 'Average Points', width: 200 },
]

export function BuildPerformanceRows(results) {
    let resultsarray = [];
    let result = _.mapObject(results, function(val,key) {
        val['name'] = key;
        resultsarray.push(val);
        val['id'] = val['name'];
        return val
    });
    return resultsarray;
    
}

export function BuildPlacingsRows(placings: PlacingWithCaptainVice[]) {
    let rows = [];
    if (placings) {
        placings.map(function(placing) {
            rows.push({
                id: placing.team.teamid,
                theid: placing.team.id,
                captain: placing.captain.player,
                vice: placing.vice.player,
                teamname: placing.team.name,
                ...placing
            })
        })
    }
    return rows;
}

export function BuildGamesTable(games:Game[]) {
    let datagridrows = games.map(function(game,index) {
        
        let oppositionname = game.opposition?.name ? game?.opposition?.name : '';
        let oppositioncolors:string[] = TeamsList[oppositionname];
        let predictedPriceChange:number = game.nextRoundPredictedPrice - game.price;
        let positionsArray:string[] = game.positions.map(function(pos){ return pos.name});
        
        
        return ({
            id: `${game.linkedmatchid}-${index}`,
            season: game.season,
            round: game.round,
            opposition: oppositionname,
            oppositionlogo: TeamLogos[oppositionname],
            points: game.points,
            price: game.price.toLocaleString('en-US', { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}),
            price_change: game.price_change,
            position: game.position?.name,
            oppositioncolors: oppositioncolors,
            game: game,
            posrdrank: game.posrdrank,
            postotalrank: game.posrank,
            scbe: game.scbe,
            nextroundpoints: game.nextRoundPredictedPoints,
            nextroundprice: game.nextRoundPredictedPrice,
            predictedPriceChange: predictedPriceChange,
            runs: game.runs,
            fours: game.fours,
            wickets: game.wickets,
            maiden_overs: game.maiden_overs,
            dotballs: game.dotballs,
            catches: game.catches,
            runouts: game.runouts,
            stumpings: game.stumpings,
            positions: game.positions,
        })
    });
    return datagridrows;
}

export function BuildBowlingTable(games: Game[]) {
    let datagridrows = games.map(function(game,index) {
        let oppositionname = game.opposition?.name ? game?.opposition?.name : '';
        let oppositioncolors:string[] = TeamsList[oppositionname];
        return ({
            id: `${game.linkedmatchid}-${index}`,
            season: game.season,
            round: game.round,
            game: game,
            opposition: oppositionname,
            oppositionlogo: TeamLogos[oppositionname],
            oppositioncolors: oppositioncolors,
            playingRoles: game.playingRoles,
            bowlingStyles: game.bowlingStyles,
            oversBowled: game.oversBowled,
            ballsBowled: game.ballsBowled,
            maidensBowled: game.maidensBowled,
            conceded: game.conceded,
            economy: game.economy,
            runsPerBall: game.runsPerBall,
            dotsBowled: game.dotsBowled,
            foursConceeded: game.foursConceeded,
            sixesConceeded: game.sixesConceeded,
            widesConceeded: game.widesConceeded,
            noballsBowled: game.noballsBowled,
            wicketsTaken: game.wicketsTaken,
        });
    });
    return datagridrows
}

export const BowlingTableColumns:GridColDef[] = [
    { field: 'season', headerName: 'Season', width: 100 },
    { field: 'round', headerName: 'Round', width: 50 },
    { field: 'opposition', headerName: 'Opponent', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCellToolTip(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors,params.row.game))
    },
    { field: 'playingRoles', headerName: 'Role', width: 200 },
    { field: 'bowlingStyles', headerName: 'Style', width: 200 },
    { field: 'oversBowled', headerName: 'Overs Bowled', type:"number"},
    { field: 'wicketsTaken', headerName: 'Wickets Taken', type:"number", width: 170},
    { field: 'maidensBowled', headerName: 'Maidens', type:"number"},
    { field: 'dotsBowled', headerName: 'Dots', type:"number"},
    { field: 'noballsBowled', headerName: 'No Balls', type:"number"},
    { field: 'conceded', headerName: 'Runs Conceded', type:"number", width: 180},
    { field: 'economy', headerName: 'Economy', type:"number"},
    { field: 'runsPerBall', headerName: 'Runs Per Ball', type:"number"},
    { field: 'foursConceeded', headerName: 'Fours', type:"number"},
    { field: 'sixesConceeded', headerName: 'Sixes', type:"number"},
    { field: 'widesConceeded', headerName: 'Wides', type:"number"},
];

export const BattingTableColumns:GridColDef[] = [
    { field: 'season', headerName: 'Season', width: 100 },
    { field: 'round', headerName: 'Rd', width: 50 },
    { field: 'opposition', headerName: 'Opponent', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCellToolTip(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors,params.row.game))
    },
    { field: 'playingRoles', headerName: 'Role', width: 200},
    { field: 'battingStyles', headerName: 'Batting Style', width: 200 },
    { field: 'runs', headerName: 'Runs',type:"number"},
    { field: 'ballsFaced', headerName: 'Balls Faced',type:"number"},
    { field: 'foursHit', headerName: 'Fours',type:"number"},
    { field: 'sixesHit', headerName: 'Sixes',type:"number"},
    { field: 'strikeRate', headerName: 'Strike Rate',type:"number"},
    { field: 'gotOut', headerName: 'Out?'},
];

export function BuildBattingTable(games: Game[]) {
    let datagridrows = games.map(function(game,index) {
        let oppositionname = game.opposition?.name ? game?.opposition?.name : '';
        let oppositioncolors:string[] = TeamsList[oppositionname];
        return ({
            id: `${game.linkedmatchid}-${index}`,
            season: game.season,
            game: game,
            round: game.round,
            playingRoles: game.playingRoles,
            opposition: oppositionname,
            oppositionlogo: TeamLogos[oppositionname],
            oppositioncolors: oppositioncolors,
            battingStyles: game.battingStyles,
            ballsFaced: game.ballsFaced,
            foursHit: game.foursHit,
            sixesHit: game.sixesHit,
            strikeRate: game.strikeRate,
            gotOut: game.gotOut === 'True' ? "Out" : "Not Out",
            runs: game.runs,
        });
    });
    return datagridrows
}

export function RenderDismissalImage(player:Player) {
    const playerimg = player.pic !== '' ? player.pic : 'https://www.nrlsupercoachstats.com/highcharts/PlayerPictures/2021/Trbojevic,%20Tom.png';
    return <div style={{position: "relative", 
        backgroundImage: `url(${playerimg})`, 
        backgroundSize: "cover", 
        borderRadius: "50%", 
        height: '2rem',
        width: '2rem',
    }}>
    </div>
}
export function RenderOverImage(player:Player) {
    let playerimg = '';
    if (player) {
        playerimg = player.pic !== '' ? player?.pic : 'https://www.nrlsupercoachstats.com/highcharts/PlayerPictures/2021/Trbojevic,%20Tom.png';
    } 
    
    return <div style={{display: "flex", alignItems: "center", columnGap: "0.5rem"}}>
        <div style={{position: "relative", 
        backgroundImage: `url(${playerimg})`, 
        backgroundSize: "cover", 
        borderRadius: "50%", 
        height: '2rem',
        width: '2rem',
    }}>
    </div>
    <span>{player ? player.firstname[0] : ''} {player? player.lastname : ''}</span>
    </div>
} 

export const DismissalColumns:GridColDef[] = [
    { field: 'season', headerName: 'Season', width: 100 },
    { field: 'round', headerName: 'Round', width: 50 },
    { field: 'opposition', headerName: 'Opponent', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderTeamCellToolTip(params.row.opposition, params.row.oppositionlogo, params.row.oppositioncolors,params.row.game))
    },
    { field: 'bowler', headerName: 'Bowler', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderDismissalImage(params.row.bowler))
    },
    { field: 'bowler', headerName: 'Bowler', width: 190,
        renderCell: (params: GridRenderCellParams<Date>) => (RenderDismissalImage(params.row.bowler))
    },
    
    { field: 'dismissalType', headerName: 'Dismissal Type' },
    { field: 'batterruns', headerName: 'Batters Runs',type:"number"},
    { field: 'bowlingStyles', headerName: 'Bowling Style', width: 200 },
    { field: 'battingStyles', headerName: 'Batting Style', width: 200 },
    { field: 'fowOrder', headerName: 'FOW Order',type:"number"},
    { field: 'fowRuns', headerName: 'FOW Runs',type:"number"},
    { field: 'fowOvers', headerName: 'FOW Overs',type:"number"},
];

export function BuildDismissalTable(dismissals: Dismissal[],thePlayerID) {
    let datagridrows = dismissals.map(function(dismissal,index) {
        let oppositionname = '';
        //@ts-ignore
        if (thePlayerID === dismissal.thegame.player[0]) {
            oppositionname = dismissal.opposition.name;
        } else {
            oppositionname = dismissal.team.name;
        }
        //let oppositionname = dismissal.opposition?.name ? dismissal?.opposition?.name : '';
        let oppositioncolors:string[] = TeamsList[oppositionname];
        return ({
            id: `${dismissal.thegame.linkedmatchid}-${index}`,
            season: dismissal.thegame.season,
            game: dismissal.thegame,
            round: dismissal.thegame.round,
            dismissalType: dismissal.dismissalType,
            batterruns: dismissal.batterruns,
            bowlingStyles: dismissal.bowlingStyles,
            battingStyles: dismissal.battingStyles,
            fowOrder: dismissal.fowOrder,
            fowRuns: dismissal.fowRuns,
            fowOvers: dismissal.fowOvers,
            batter: dismissal.batter,
            bowler: dismissal.bowler,
        });
    });
    return datagridrows
}
